import { COMMON_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from "@dehaat/dds";
import RoundCross from "app/farmer360/image-diagnosis/assests/icons/RoundCross";
import RoundEmptyTick from "app/farmer360/image-diagnosis/assests/icons/RoundEmptyTick";
import React from "react";
import { Image, View, Text, StyleSheet, Dimensions } from "react-native";
const { width } = Dimensions.get("window");

interface Props {
  source: any;
  blurStatus: string;
}
const ImgStatusText = ({ source, blurStatus }: Props) => {
  return (
    <View
      style={[
        COMMON_STYLES.flex1,
        COMMON_STYLES.alignItemsCenter,
        COMMON_STYLES.justifyBetween,
      ]}
    >
      <Image
        source={source}
        style={[
          COMMON_STYLES.mb1,
          COMMON_STYLES.br1,
          {
            width: 140,
            height: 170,
          },
        ]}
      />
      <View
        style={{ flexDirection: "row", alignItems: "center", marginTop: 8 }}
      >
        {blurStatus === "Good focus" || blurStatus === "Good View" ? (
          <RoundEmptyTick width={20} height={20} />
        ) : (
          <RoundCross width={20} height={20} />
        )}
        <Text
          style={[TYPOGRAPHY.TEXT2, VARIANTS_STYLES.BASE, { marginLeft: 8 }]}
        >
          {blurStatus}
        </Text>
      </View>
    </View>
  );
};

export default ImgStatusText;
